export const UPDATE_TEMP_DRAWINGS = "UPDATE_TEMP_DRAWINGS";
export const updateTempDrawings = (data) => {
  return {
    type: UPDATE_TEMP_DRAWINGS,
    data: data,
  };
};


